/**
 * 增强模式(步骤)
 */

import React, { useEffect, useMemo, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/helper';
import { SVGPureIcon } from '@/ui';
import EnhanceStore from './store';
import appLogger from '@public/log/monitor';
import client from '@/store/client';
import "./index.scss";

// 用于显示打点
const Tips = observer((props) => {
  // const {
  //   messageId,
  // } = useMessageContext();
  // const {
  //   tips,
  //   folded,
  // } = props;
  // const search_keyword_total = tips?.length || 0;

  // useEffect(() => {
  //   if(tips?.length){
  //     const extList = {};
  //     tips.forEach((item, index) => {
  //       extList[`ext${index + 1}`] = item.content;
  //     });
  //   }
  // }, [messageId, search_keyword_total]);

  return null;
});

const Enhance = observer((props) => {
  const {
    type = "flow",          // flow: 工作流步骤
    folded = false,         // 是否折叠(工作流步骤)
    flows,                  // 工作流步骤
    className = '',
    isCompleted = false,    // 消息已结束
    messageItem,
    chatStore,
  } = props;

  const store = useLocalObservable(() => new EnhanceStore({ type }));
  const [secondUnfolded, setSecondUnfolded] = useState(false)
  useEffect(() => {
    store.updateData({ type });
  }, [type]);
  useEffect(() => {
    store.updateData({ isFolded: folded });
  }, [folded]);
  useEffect(() => {
    store.updateData({ flows });
  }, [flows]);

  const flowOver = isCompleted || (store.flows || []).find(item => item.isResult); // 工作流步骤是否已完成

  const enhanceTitle = useMemo(() => {
    if(flows?.search_total){
      return `找到 ${flows.refer_search?.length || 0} 篇资料作为参考`;
    }

    return "AI智能处理中";
  }, [flows]);

  // 直接走大模型，没走猜词，参考
  if((isCompleted || folded) && !flows?.refer_search?.length){
    return null;
  }

  return (
    <div className={`${store.isFolded ? 'w-400px' : 'w-full'} pb-8px pt-8px`}>
      <div
        className={`w-full rounded-[12px] px-[12px] py-[12px] bg-[#F6F7F9] relative ${store.isFolded ? 'hover:bg-[#F0F2F5]' : ''} ${className}`}
        >
        <div
          className={`w-full flex h-[20px] items-center justify-between ${store.supportFold && store.isFolded ? "cursor-pointer" : ""}`}
          onClick={
            () => {
              if(!store.supportFold){
                return;
              }
              if(!store.isFolded){
                return;
              }
              store.toggleFolded();
              setSecondUnfolded(false)
            }
          }>
          <div className="text-[14px] text-black text-opacity-80 flex items-center w-0 flex-grow relative">
            <div className="w-[20px] h-[20px]" style={{ background: `url(https://p5.ssl.qhimg.com/t010cf28591542ba2c0.png) center center / cover no-repeat` }}></div>
            <div className='ml-[8px]'>{enhanceTitle}</div>
            {
              store.isFolded
              ? (
                <div className='select-none text-black text-opacity-50 pr-[16px] font-normal absolute right-0'>{store.flows.length}步已完成</div>
              )
              : null
            }
          </div>
          {
            store.supportFold
            ? (
              <div
                className={`size-[16px] flex items-center justify-center cursor-pointer transition-transform transition-[0.25s] transform ${!store.isFolded ? 'absolute top-10px right-10px !size-24px hover:bg-black hover:bg-opacity-5 rounded-full' : 'rotate-[180deg]'}`}
                onClick={
                  (event) => {
                    if(!store.supportFold){
                      return;
                    }
                    if(store.isFolded){
                      return;
                    }

                    event.stopPropagation();
                    store.toggleFolded();
                    setSecondUnfolded(false)
                  }
                }
                >
                <div className="w-[12px] h-[7px] opacity-70 text-black" style={{
                  background: "url(https://p1.ssl.qhimg.com/t11098f6bcd68c1f657473c7301.png) center center / cover no-repeat"
                }}>
                </div>
              </div>
            )
            : null
          }
        </div>

        <div className={`w-full flex mt-[20px] text-left text-black text-opacity-80 text-[12px] leading-[17px] ${store.isFolded ? "hidden" : ""}`}>
          <div className='w-full'>
            {
              store.flows.map((item, index) => {
                const isLast = index == store.flows.length - 1;
                const isLoading = isLast && !flowOver;
                const hasTips = item.tips?.length;
                const isRefer = item.isRefer && item.list?.length;

                return (
                  <div
                    className=''
                    key={index}
                    >
                    <div className={`flex w-full text-14px ${isLast && !hasTips && !isRefer ? "mb-0px" : hasTips || isRefer ? "mb-[12px]" : "mb-[16px]"}`}>
                      {
                        isLoading
                        ? <div className='ani-rotate animate-ease-in-out w-[20px] h-[20px]' style={{ background: "url(https://p2.ssl.qhimg.com/t01a7c16decb3e12279.png) center center / cover no-repeat" }}></div>
                        : <div className='w-[20px] h-[20px]' style={{ background: `url(https://p2.ssl.qhimg.com/t01056c3ea6c952c373.png) center center / cover no-repeat` }}></div>
                      }
                      <div className="w-0 flex-grow ml-[8px] leading-[20px]">
                        <div className="" dangerouslySetInnerHTML={{ __html : HelperCore.xss(item.text) }}></div>
                      </div>
                    </div>
                    {
                      // 参考资料多一个节点？
                      !isLoading && isRefer
                      ? (
                        <div className={`flex w-full text-14px mb-[12px]`}>
                          <div className='w-[20px] h-[20px]' style={{ background: `url(https://p0.ssl.qhimg.com/t11098f6bcdb4ff2b478a130908.png) center center / cover no-repeat` }}></div>
                          <div className="w-0 flex-grow ml-[8px] leading-[20px]">
                            <div className="">参考资料</div>
                          </div>
                        </div>
                      )
                      : null
                    }
                    {
                      hasTips
                      ? (
                        <div className="pb-[8px] pl-[24px] flex flex-wrap">
                          <Tips key="tip_logger" tips={item.tips} folded={store.isFolded} />
                          {
                            item.tips.map(item => {
                              return (
                                <div
                                  key={item.content}
                                  onClick={
                                    () => {
                                      const message = chatStore.messageMap.get(messageItem.msg_id);
                                      chatStore.sendMessage({
                                        input : item.content,
                                        asstId : message.role_id,
                                      });
                                      appLogger.log({
                                        key: "aibot_plugin",
                                        action: 'click',
                                        arrt: 'aibot_plugin_sidebar_chat_keyword', 
                                        ext: item.content
                                      });
                                      appLogger.log({
                                        key: "aibot_plugin",
                                        action: 'act',
                                        arrt: 'new_chat', 
                                        ext: "chat_keyword",
                                        ex1: item.content,
                                      });
                                    }
                                  }
                                  className="mr-[8px] mb-[8px] px-[12px] h-[24px] leading-[24px] text-[12px] text-black text-opacity-90 rounded-[6px] bg-white hover:bg-[#F0F2F5] hover:font-bold cursor-pointer truncate">
                                  {item.content}
                                </div>
                              )
                            })
                          }
                        </div>
                      )
                      : null
                    }
                    {
                      isRefer
                      ? (
                        <div className="ml-[26px]  bg-white text-left rounded-[12px] p-[12px] text-[12px] leading-[17px]">
                          {/* 最多展示10条, 没有再次折叠逻辑 */}
                          {
                            (secondUnfolded ? (item.list): item.list.slice(0,10)).map((site, index) => {
                              return (
                                <div
                                  key={site.title + index}
                                  className='mb-[14px]'
                                  onClick={() => {
                                    appLogger.log({
                                      key: "aibot_plugin",
                                      action: 'click',
                                      arrt: 'aibot_plugin_sidebar_chat_site', 
                                      ext: site.title,
                                      ext1: site.url
                                    });
                                  }}
                                >
                                  <a
                                    target='_blank'
                                    href={site.url}
                                    onClick={
                                      event => {
                                        if(client.isClient){
                                          client.run("OpenUrl", null, site.url);
                                          event.preventDefault();
                                        }
                                      }
                                    }
                                    className='!text-[#1465FF] break-all inline-block hover:font-bold !hover:underline'
                                    dangerouslySetInnerHTML={{ __html : `${index+1}. ${HelperCore.xss(site.title)}` }}
                                    >
                                  </a>
                                  {/* {
                                    site.site
                                    ? (
                                      <span className="text-black text-opacity-50 inline-block pl-4px">{site.site}</span>
                                    )
                                    : null
                                  }
                                  {
                                    site.date
                                    ? (
                                      <span className="text-black text-opacity-50 inline-block pl-4px">[{site.date}]</span>
                                    )
                                    : null
                                  } */}
                                </div>
                              )
                            })
                          }
                          {item.list.length > 10 && !secondUnfolded ? <div className='w-full leading-17px text-12px pb-12px pt-2px flex justify-center items-center gap-[5px] opacity-50 hover:opacity-80 hover:font-bold cursor-pointer select-none' onClick={()=>{setSecondUnfolded(true)}}>展开全部<SVGPureIcon className="w-9px h-8px" name="icon_double_down"></SVGPureIcon></div>:null}
                        </div>
                      )
                      : null
                    }
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
});
export default Enhance;